module.exports = function() {
  return new Worker(__webpack_public_path__ + "a0d669cadebec8659b60.worker.js");
};